module.exports = __webpack_public_path__ + "6b2e54002baa14f2c7a30266f8ad60af.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_3-420.webp.png
// module id = 303
// module chunks = 0